module.exports = __webpack_public_path__ + "static/lk-497ee5b9544ffc29720476b7085f7503.svg";